import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetTargetingCategoryMonth  {
    _originalTypeClassName = "zERP.BO.BudgetTargetingCategoryMonth";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetTargetingCategoryMonth.translate = translateService;
}
this.Category = new Domain.BudgetTargetingCategory();
this.Id = null;
this.Month = null;
this.Amount = null;
this.MonthStr = null;
this.ExecutionAmount = null;
this.DiscrepanciesAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
Amount:any;
MonthStr:any;
ExecutionAmount:any;
DiscrepanciesAmount:any;
Category:any;
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}

static GetCalendarMonth($this: any): any{switch ($this?.Month) {case 1:
{
return 1;}
case 2:
{
return 2;}
case 3:
{
return 3;}
case 5:
{
return 4;}
case 6:
{
return 5;}
case 7:
{
return 6;}
case 9:
{
return 7;}
case 10:
{
return 8;}
case 11:
{
return 9;}
case 13:
{
return 10;}
case 14:
{
return 11;}
case 15:
{
return 12;}
default:
{
return 0;}
}
return 0;
}
static GetMonthStr($this: any): any{switch ($this?.Month) {case 1:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_1');}
case 2:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_2');}
case 3:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_3');}
case 4:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_4');}
case 5:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_5');}
case 6:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_6');}
case 7:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_7');}
case 8:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_8');}
case 9:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_9');}
case 10:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_10');}
case 11:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_11');}
case 12:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_12');}
case 13:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_13');}
case 14:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_14');}
case 15:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_15');}
case 16:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_16');}
case 17:
{
return this.translate.instant('BudgetTargetingBO_RES_CUSTOM_MONTH_17');}
default:
{
return "";}
}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}